import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Contexts from "../../contexts/Contexts";
import { useUserBalance } from "../../api/hooks/user";
import { StrToCurrency } from "../../api/ApiGame";
import styles from "./index.module.css";

// Auto-generated token names contain digits and no spaces — fall back to "você"
const isTokenName = (name: string) => /\d/.test(name) || name.length > 20;

const WelcomeBanner: React.FC<{ upcomingDraw?: any }> = ({ upcomingDraw }) => {
  const { user, userId, screenSize, storefront } = useContext(Contexts);
  const { balance, fetchBalance } = useUserBalance();
  const navigate = useNavigate();

  useEffect(() => {
    if (userId) fetchBalance();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  if (!userId || !user || user.isGuest) return null;

  const rawNick = user.nickName;
  const displayName =
    rawNick && !isTokenName(rawNick)
      ? rawNick
      : user.profileName && !isTokenName(user.profileName)
      ? user.profileName
      : user.name && !isTokenName(user.name)
      ? user.name
      : "você";
  const balanceAmount = balance?.amount ? parseFloat(balance.amount) : 0;
  const hasBalance = balanceAmount > 0;

  // BUNDLE 4c: handleDeposit removed from customer-facing flows.
  // DepositDrawer component retained for internal/operational use only. Do not re-expose without legal review.

  // Compact single-row banner for small screens
  if (screenSize.isMobile) {
    return (
      <div className={styles.bannerCompact}>
        <div className={styles.compactAvatar}>
          {displayName.charAt(0).toUpperCase()}
        </div>
        <div className={styles.compactText}>
          <span className={styles.compactName}>Olá, {displayName}!</span>
          {/* Prêmios = Prizes (EN). Renamed from "saldo" in Bundle 4c. */}
          <span className={styles.compactBalance}>{StrToCurrency(balanceAmount)}</span>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.banner} style={{ position: 'relative', overflow: 'hidden' }}>
      {/* Affiliate watermark logo in bottom-right */}
      {storefront?.logo_url && (
        <img
          src={storefront.logo_url}
          alt=""
          aria-hidden
          width={120}
          height={80}
          loading="lazy"
          decoding="async"
          style={{
            position: 'absolute',
            bottom: -8,
            right: -8,
            height: 80,
            maxWidth: 120,
            objectFit: 'contain',
            opacity: 0.06,
            pointerEvents: 'none',
            userSelect: 'none',
          }}
        />
      )}
      <div className={styles.greeting}>
        {storefront && (
          <span style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            background: `${'#fff'}22`,
            border: `1px solid ${'#fff'}66`,
            color: '#fff',
            fontSize: 11,
            fontWeight: 700,
            padding: '3px 8px',
            borderRadius: 20,
            marginBottom: 6,
            alignSelf: 'flex-start',
          }}>
            Ofertas de {storefront.display_name}
          </span>
        )}
        <span className={styles.greetingTop}>
          {hasBalance ? "Bem-vindo de volta 👋" : "Conta criada com sucesso! 🎉"}
        </span>
        <span className={styles.greetingName}>Olá, {displayName}!</span>
      </div>

      <div className={styles.balanceCard}>
        <div>
          {/* Prêmios = Prizes (EN). Renamed from "saldo" in Bundle 4c. */}
          <div className={styles.balanceLabel}>Seus prêmios</div>
          <div className={styles.balanceAmount}>
            {StrToCurrency(balanceAmount)}
          </div>
        </div>
        {/* BUNDLE 4c: "Adicionar saldo" CTA removed. DepositDrawer retained for internal use only. */}
      </div>

      {!hasBalance && (
        <div className={styles.nudge}>
          <div className={styles.nudgeTitle}>Pronto para sua primeira aposta?</div>
          <div className={styles.nudgeSub}>
            Participe do próximo sorteio
            {upcomingDraw ? ` da ${upcomingDraw.game?.gameName} — prêmio de ${StrToCurrency(upcomingDraw.draw?.mainPrize || 0)}!` : "!"}
          </div>
          <button className={styles.nudgeBtn} onClick={() => navigate("/")}>
            💛 Jogue agora
          </button>
        </div>
      )}

      {hasBalance && (
        <div className={styles.suggestions}>
          <div className={styles.suggestionsTitle}>Sugestões para você</div>
          {upcomingDraw && (
            <div
              className={styles.actionItem}
              onClick={() => navigate(`/games/${upcomingDraw.game?.gameId}`)}
            >
              <div className={`${styles.actionIcon} ${styles.yellow}`}>🎰</div>
              <div className={styles.actionText}>
                <strong>{upcomingDraw.game?.gameName}</strong>
                <span>Sorteio em breve · {upcomingDraw.draw?.mainPrize ? StrToCurrency(upcomingDraw.draw.mainPrize) : "Prêmio a confirmar"}</span>
              </div>
              <span className={styles.actionArrow}>›</span>
            </div>
          )}
          <div className={styles.actionItem} onClick={() => navigate("/groups")}>
            <div className={`${styles.actionIcon} ${styles.blue}`}>👥</div>
            <div className={styles.actionText}>
              <strong>Entrar em um Bolão</strong>
              <span>Aposte em grupo, divida os prêmios</span>
            </div>
            <span className={styles.actionArrow}>›</span>
          </div>
          <div className={styles.actionItem} onClick={() => navigate("/my-tickets")}>
            <div className={`${styles.actionIcon} ${styles.green}`}>🎟️</div>
            <div className={styles.actionText}>
              <strong>Minhas Apostas</strong>
              <span>Acompanhe seus bilhetes</span>
            </div>
            <span className={styles.actionArrow}>›</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default WelcomeBanner;
